import "@eastdesire/jscolor";
let tinycolor = require("vendor/tiny_color.min")
import {confirmPlus} from 'admin/common/custom_confirm'

class BrandingPage extends HTMLElement {
  constructor() {
    super();
    this.current_group_id = Common.getSelectedAutoGroupIdFromCookie();
    this.group_id = document.getElementById('object_id').value;
  }
  async connectedCallback(changed = false) {
    
    let branding_res = await fetch(`/admin/groups/${this.group_id}/branding`);
    let branding_data = await branding_res.json();

    let no_branding_message = "";
    if(branding_data.id == null) {
      no_branding_message = "<p class='no-branding'>This Group does not have a Branding saved. Design and save your Branding here.</p>"
    }

    this.colors = [{type: 'header', color: branding_data ? branding_data.header_color : BrandingPage.COLORS.header_color},
                    {type: 'sidebar', color: branding_data ? branding_data.sidebar_color : BrandingPage.COLORS.sidebar_color},
                    {type: 'panel_header', color: branding_data ? branding_data.panel_header_color : BrandingPage.COLORS.panel_header_color},
                    {type: 'table_header', color: branding_data ? branding_data.table_header_color : BrandingPage.COLORS.table_header_color}];
    this.innerHTML = `
      <style>
        #color-form {
          display: flex;
          justify-content: space-around;
        }

        #brandingDropzone {
          height: 100px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .preview-timer {
          display: inline-block;
          margin-right: 10px;
        }

        .preview-timer .btn {
          margin-left: 10px;
        }

        .preview-remaining {
          font-size: 14px;
          font-weight: 600;
        }

        #logo-form img {
          max-height: 50px;
        }

        .jscolor-container {
          text-align: center;
        }
      </style>
      <h3>Branding</h3>
      ${no_branding_message}
      <div class="row" id="logo-form">
        <p><strong>Current Logo:</strong></p>
        <div>
          ${branding_data && branding_data.logo.url ? `<img id='logo_placeholder' src="${branding_data.logo.url}" />` : ''}
        </div>
        <div class="well" id="brandingDropzone">
          <p>Double Click or Drop your logo image files here to upload.</p>
        </div>
      </div>

      <div class="row well" id="color-form">
          <div class="col-sm-3 jscolor-container">
            <label>Header Color</label>
            <input type="text" id="header_color" name="header_color" class="form-control" value="${branding_data ? branding_data.header_color : ''}">
          </div>
          <div class="col-sm-3 jscolor-container">
            <label>Sidebar Color</label>
            <input type="text" id="sidebar_color" name="sidebar_color" class="form-control" value="${branding_data ? branding_data.sidebar_color : ''}">
          </div>
          <div class="col-sm-3 jscolor-container">
            <label>Panel Header Color</label>
            <input type="text" id="panel_header_color" name="panel_header_color" class="form-control" value="${branding_data ? branding_data.panel_header_color : ''}">
          </div>
          <div class="col-sm-3 jscolor-container">
            <label>Table Header Color</label>
            <input type="text" id="table_header_color" name="table_header_color" class="form-control" value="${branding_data ? branding_data.table_header_color : ''}">
          </div>
        
      </div>

      <button title='Use the default colors' id='revert_colors' class="btn btn-outline-danger pull-left">Revert to Default Branding</button>
      <button id='branding-submit' class="btn btn-primary pull-right">Save Branding</button>
      <div class="preview-timer pull-right">
        <span class="preview-remaining hidden">Preview ends in <span class="preview-time">10</span> seconds</span>
        <button id='branding-preview' class="btn btn-secondary">Preview Colors</button>
      </div>

      <input type='hidden' name='highlight_color' id="highlight_color" class="required" value="${branding_data ? branding_data.highlight_color : ''}"/>
      <input type='hidden' name='active_color' id="active_color" class="required" value="${branding_data ? branding_data.active_color : ''}"/>
      <input type='hidden' name='header_text_color' id="header_text_color" class="required" value="${branding_data ? branding_data.header_text_color : ''}"/>
      <input type='hidden' name='sidebar_text_color' id="sidebar_text_color" class="required" value="${branding_data ? branding_data.sidebar_text_color : ''}"/>
      <input type='hidden' name='panel_text_color' id="panel_text_color" class="required" value="${branding_data ? branding_data.panel_text_color : ''}"/>
      <input type='hidden' name='table_text_color' id="table_text_color" class="required" value="${branding_data ? branding_data.table_text_color : ''}"/>`;
      
    this.initColorpickers();
    this.colorChangeHandlers();
    this.initFileUpload();
    this.saveOriginalColors();

    if(changed && this.group_id == this.current_group_id) {
      this.updateCurrentPageBranding(branding_data);
    }
    this.querySelector('#revert_colors').addEventListener('click', function() {
      this.revertColors();
    }.bind(this))
    this.querySelector('#branding-preview').addEventListener('click', function() {
      this.previewBranding();
    }.bind(this))

  }
  initColorpickers() {
    this.colors.forEach(color => {
      let picker = new JSColor(`#${color.type}_color`);
    })
  }


  initFileUpload() {
    let dz = new Dropzone('#brandingDropzone', { 
      url: `/admin/groups/${this.group_id}/branding`,
      autoProcessQueue: false,
      uploadMultiple: true,
      paramName: "file",
      maxFilesize: 2,
      maxFiles: 1,
      addRemoveLinks: true,
      dictDefaultMessage: "Click or Drop your logo image files here to upload.",
      dictMaxFilesExceeded: "Only one logo may be selected.",
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
      },
      accept: function(file, done) {
        if ( $(this).hasClass('dz-max-files-reached') ) {}

        if (!(/\.(gif|jpg|jpeg|tiff|png)$/i).test(file.name)) {
          done("Unsupported File Type");
        }
        else { done(); }
      },
      // The setting up of the dropzone
      init: function() {
        let myDropzone = this;

        // First change the button to actually tell Dropzone to process the queue.
        document.querySelector("#branding-submit").addEventListener('click', function(e) {
          // Make sure that the form isn't actually being sent.
          e.preventDefault();
          e.stopPropagation();

          // We want to force form sumbission even if no logo is provided
          if (myDropzone.getQueuedFiles().length > 0) {                        
            myDropzone.processQueue();  
          } else {              
            let mockFile = new File([""], 'nofiles');          
            myDropzone.uploadFiles([mockFile]); //send empty 
          }    
        });

        // When we send image data, we need to include all the other form data
        this.on("sending", function(data, xhr, formData) {
          $.each($('branding-page input, branding-page hidden, branding-page select'), function(k,v){
            var v = $(this).val();
            var k = $(this).attr('name');
            formData.append(k, v);
          })
        });

        // Refresh page on success so uploaded logo appears on page and menu bar
        myDropzone.on("success", function(file, response) {
          myDropzone.removeFile(file);
          Common.updateBranding();
          if (response) {
            document.querySelector("branding-page").connectedCallback(true);
            Common.notify('Branding updated.', 'success')
          } else {
            Common.notify(responseText.message, 'danger');
          }
        });

        myDropzone.on("maxfilesexceeded", function(file, responseText) {
        });

        myDropzone.on("error", function(file, error) {
          myDropzone.removeFile(file);
          Common.notify( error, 'danger');
        });

        myDropzone.on("processing", function(file) {
        });

        myDropzone.on("maxfilesreached", function(file) {
        });

        myDropzone.on("queuecomplete", function(file) {
        });
      }
    });
  }

  colorChangeHandlers() {    
    this.querySelector('#header_color').onchange = (function(e){
      let v = this.querySelector('#header_color').value;
      let header_color = tinycolor(v);
  
      let header_text_color = '';
      if (header_color.isLight()) {
        header_text_color = tinycolor(v).darken(60).toString();
      }
      else {
        header_text_color = tinycolor(v).lighten(60).toString();
      }
      this.querySelector('#header_text_color').value = header_text_color;
    }.bind(this));
  
    this.querySelector('#sidebar_color').onchange = (function(e){
      let v = this.querySelector('#sidebar_color').value;
  
      // Geneate hover/highlight colors based on the selected side bar color.
      let sidebar_color = tinycolor(v);
      let highlight_color = '';
      let active_color = '';
      let sidebar_text_color = '';
      if (sidebar_color.isLight()) {
        highlight_color = tinycolor(v).darken(20).toString();
        active_color = tinycolor(v).darken(10).toString();
        sidebar_text_color = tinycolor(v).darken(60).toString();
      }
      else {
        highlight_color = tinycolor(v).lighten(20).toString();
        active_color = tinycolor(v).lighten(10).toString();
        sidebar_text_color = tinycolor(v).lighten(60).toString();
      }
  
      this.querySelector('#highlight_color').value = highlight_color;
      this.querySelector('#active_color').value = active_color;
      this.querySelector('#sidebar_text_color').value = sidebar_text_color;
    }.bind(this));

    this.querySelector('#panel_header_color').onchange = (function(e){
      let v = this.querySelector('#panel_header_color').value;
      let header_color = tinycolor(v);
      
      let header_text_color = '';
      if (header_color.isLight()) {
        header_text_color = tinycolor(v).darken(60).toString();
      }
      else {
        header_text_color = tinycolor(v).lighten(60).toString();
      }
      this.querySelector('#panel_text_color').value = header_text_color;
    }.bind(this));

    this.querySelector('#table_header_color').onchange = (function(e){
      let v = this.querySelector('#table_header_color').value;
      let header_color = tinycolor(v);
  
      let header_text_color = '';
      if (header_color.isLight()) {
        header_text_color = tinycolor(v).darken(60).toString();
      }
      else {
        header_text_color = tinycolor(v).lighten(60).toString();
      }
      this.querySelector('#table_text_color').value = header_text_color;
    }.bind(this));
  }

  async revertColors() {
    if(await confirmPlus('Are you sure you want to Delete to the Default Branding?')) {
      
      let result = await fetch(`/brandings/${this.group_id}/delete_branding`, {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
          'Content-Type': 'application/json'
        },
      })
      if(result.ok) {
        Common.notify('Branding colors have been deleted', 'success');
        this.connectedCallback(true);
      }
      else Common.notify('Failed to delete branding', 'error');
    
    }
  }

  // updateBranding(branding) {
  //   this.querySelector('#header_text_color').value = branding.header_text_color;
  //   this.querySelector('#highlight_color').value = branding.highlight_color;
  //   this.querySelector('#active_color').value = branding.active_color;
  //   this.querySelector('#sidebar_text_color').value = branding.sidebar_text_color;
  //   this.querySelector('#panel_text_color').value = branding.panel_text_color;
  //   this.querySelector('#table_text_color').value = branding.table_text_color;
  // }

  async updateBranding() {
    let group_id = document.getElementById('object_id').value;
    let data = {
      header_color: this.querySelector('#header_color').value,
      sidebar_color: this.querySelector('#sidebar_color').value,
      panel_header_color: this.querySelector('#panel_header_color').value,
      table_header_color: this.querySelector('#table_header_color').value,
      header_text_color: this.querySelector('#header_text_color').value,
      sidebar_text_color: this.querySelector('#sidebar_text_color').value,
      panel_text_color: this.querySelector('#panel_text_color').value,
      table_text_color: this.querySelector('#table_text_color').value,
      highlight_color: this.querySelector('#highlight_color').value,
      active_color: this.querySelector('#active_color').value
    };
    let result = await fetch(`/admin/groups/${group_id}/branding`, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    if(result.ok) {
      Common.notify('Group branding updated', 'success');
    }
    else Common.notify('Failed to update branding', 'error');
  }

  updateCurrentPageBranding(branding) {
    Common.clear_custom_branding();
    branding.logo ? Common.update_logo(branding.logo.url, branding.logo.thumb) : null;
    Common.update_header_color(branding.header_color);
    Common.update_messaging_header_color(branding.header_color);
    Common.update_sidebar_color(branding.sidebar_color);
    Common.update_highlight_color(branding.highlight_color);
    Common.update_active_color(branding.active_color);
    Common.update_header_text_color(branding.header_text_color);
    Common.update_sidebar_text_color(branding.sidebar_text_color);

    Common.update_panel_header_color(branding.panel_header_color);
    Common.update_panel_text_color(branding.panel_text_color);
    Common.update_table_header_color(branding.table_header_color);
    Common.update_table_text_color(branding.table_text_color);
  }

  saveOriginalColors() {
    let branding = Common.getBranding();
    this.original_colors = {
      header_color: branding != null ? branding.header_color : this.querySelector('#header_color').value,
      sidebar_color: branding != null ? branding.sidebar_color : this.querySelector('#sidebar_color').value,
      header_text_color: branding != null ? branding.header_text_color : this.querySelector('#header_text_color').value,
      sidebar_text_color:branding != null ? branding.sidebar_text_color :  this.querySelector('#sidebar_text_color').value,
      active_color:branding != null ? branding.active_color :  this.querySelector('#active_color').value
    }
  }

  previewBranding() {
    Common.update_header_color(this.querySelector('#header_color').value);
    Common.update_sidebar_color(this.querySelector('#sidebar_color').value);
    Common.update_header_text_color(this.querySelector('#header_text_color').value);
    Common.update_sidebar_text_color(this.querySelector('#sidebar_text_color').value);
    Common.update_active_color(this.querySelector('#active_color').value);
    this.querySelector('.preview-remaining').classList.remove('hidden');
    let time = 10;
    let timer = setInterval(function() {
      time --;
      this.querySelector('.preview-time').innerHTML = time;
      if(time <= 0) {
        this.revertPreview();
        clearInterval(timer)
      }
    }.bind(this), 1000)
  }

  revertPreview() {
    Common.update_header_color(this.original_colors.header_color);
    Common.update_sidebar_color(this.original_colors.sidebar_color);
    Common.update_header_text_color(this.original_colors.header_text_color);
    Common.update_sidebar_text_color(this.original_colors.sidebar_text_color);
    Common.update_active_color(this.original_colors.active_color);
    this.querySelector('.preview-remaining').classList.add('hidden');
    this.querySelector('.preview-time').innerHTML = 10;
  }
  
}

BrandingPage.COLORS = {
  header_color: '#6B6B6B',
  sidebar_color: '#6B6B6B',
  highlight_color: '#848484',
  active_color: '#848484',
  header_text_color: '#FFFFFF',
  sidebar_text_color: '#FFFFFF',
  panel_header_color: '#F5F5F5',
  panel_text_color: '#434A54',
  table_header_color: '#7CB5EC',
  table_text_color: '#FFFFFF'
}

customElements.define('branding-page', BrandingPage)